import React from 'react';

const channelsData = [
  {
    id: 'facebook',
    title: 'Facebook',
    desc: 'Facebook comes with a leading global reach and a large user base in Pakistan. The expansive reach of the channel is advantageous for businesses that need complete audience engagement. Your brand can also build a reliable community around your products and build strong customer relationships and brand loyalty. Facebook has a strong content distribution system, and your company can use it to post content in a variety of formats. The channels also allow interactive polls and live streaming. If your business also has a marketing plan that involves storytelling and connection building, Facebook is suitable for you.',
    icon: (
      <svg width="34" height="34" viewBox="0 0 24 24" fill="currentColor">
        <path d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.325v-21.35c0-.732-.593-1.325-1.325-1.325z" />
      </svg>
    )
  },
  {
    id: 'instagram',
    title: 'Instagram',
    desc: 'Instagram is now one of the best marketing platforms. There are over 2 billion monthly active users on this channel. It provides a powerful canvas for pictures and reels. It is an ideal choice to showcase products with the best imagery, engaging stories, and reels. The medium has a visual first approach, and that is why it is the best option for every business. The shopping integration features of Instagram help customers discover and purchase products. Moreover, the carousel posts, IGTV, and user-generated content campaigns work well for audience engagement and conversion optimization.',
    icon: (
      <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
        <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
        <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
      </svg>
    )
  },
  {
    id: 'x-twitter',
    title: 'X (formerly Twitter)',
    desc: 'Twitter is known for rapid-fire updates and trending topics, but it can be very advantageous for customer feedback. The portal allows you to form a quick connection with clients. It provides rapid communication between brands and their audiences and helps businesses manage their reputation. The medium has a character-limited format that helps users to craft concise and impactful messages. Industry discussions, crisis communication management, and direct customer feedback collection help brands build trust with timely interactions.',
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      </svg>
    )
  }
];

function TopSocialMediaChannelsSection() {
  const handleQuoteClick = (e) => {
    e.preventDefault();
    const formEl = document.querySelector('.contact-section') || document.getElementById('contact-form');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="top-social-channels-section">
      <div className="container">
        {/* Header Title & Subtitle */}
        <div className="top-social-channels-header">
          <h2 className="top-social-channels-title">
            Top <span style={{ color: '#c40a0a' }}>Social Media Marketing Channels:</span> Which One Is Most Suitable For You?
          </h2>
          <p className="top-social-channels-subtitle">
            You must seek assistance from our experienced social media marketing agencies in Pakistan to grow your brand online. Each framework comes with its own advantages in the online world.
          </p>
        </div>

        {/* 3 Cards Grid with 3D Flip */}
        <div className="top-social-channels-grid">
          {channelsData.map((channel) => (
            <div key={channel.id} className="social-flip-card" onClick={handleQuoteClick}>
              <div className="social-flip-card-inner">
                
                {/* Front Side: Sleek Black Card */}
                <div className="social-flip-card-front">
                  <div className="social-card-icon-wrapper">
                    {channel.icon}
                  </div>
                  <h3 className="social-card-title">{channel.title}</h3>
                  <p className="social-card-desc">{channel.desc}</p>
                </div>

                {/* Back Side (Flipped on Hover): Background Image with same text */}
                <div 
                  className="social-flip-card-back"
                  style={{
                    backgroundImage: "linear-gradient(rgba(11, 15, 25, 0.88), rgba(11, 15, 25, 0.94)), url('/assets/images/social-media/social-img4.webp')"
                  }}
                >
                  <div className="social-card-icon-wrapper">
                    {channel.icon}
                  </div>
                  <h3 className="social-card-title">{channel.title}</h3>
                  <p className="social-card-desc">{channel.desc}</p>
                </div>

              </div>
            </div>
          ))}
        </div>

        {/* Call to Action Button */}
        <div className="social-cta-btn-wrapper" style={{ marginTop: '3.5rem' }}>
          <button className="btn-social-quote-now" onClick={handleQuoteClick}>
            <span>Get Free Quote Now!</span>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <polyline points="12 16 16 12 12 8" />
              <line x1="8" y1="12" x2="16" y2="12" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
}

export default TopSocialMediaChannelsSection;
